import React from 'react';
import './StarRating.sass';

import cx from 'classnames';

export default class StarRating extends React.PureComponent {
  render() {
    const { themeColor = '#f1be44', size = 14, value = 0 } = this.props;
    const displayedValue = value;

    return (
      <div className="stars">
        {[1, 2, 3, 4, 5].map((i) => (
          <span
            key={i}
            className={cx({
              star: true,
              'svg-fill': i <= displayedValue,
              unfilled: i > displayedValue,
            })}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="svg--fill"
              width={size}
              height={size}
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M6.71468 0.878114C6.80449 0.601721 7.19551 0.601722 7.28532 0.878115L8.72876 5.32057C8.76892 5.44418 8.88411 5.52786 9.01408 5.52786H13.6851C13.9758 5.52786 14.0966 5.89975 13.8615 6.07057L10.0825 8.81616C9.97736 8.89255 9.93336 9.02796 9.97352 9.15157L11.417 13.594C11.5068 13.8704 11.1904 14.1003 10.9553 13.9294L7.17634 11.1838C7.07119 11.1074 6.92881 11.1075 6.82366 11.1838L3.04469 13.9294C2.80957 14.1003 2.49323 13.8704 2.58303 13.594L4.02648 9.15157C4.06664 9.02796 4.02264 8.89255 3.91749 8.81616L0.138516 6.07057C-0.0965979 5.89975 0.0242358 5.52786 0.314853 5.52786H4.98593C5.11589 5.52786 5.23108 5.44418 5.27124 5.32057L6.71468 0.878114Z"
                fill={themeColor}
              />
            </svg>
          </span>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/reviews/stars/StarRating.js